var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8005 5.22495C22.1421 5.57971 22.3883 6.02121 22.5145 6.50549C23.2411 9.54286 23.0732 14.3399 22.5286 17.4945C22.4024 17.9788 22.1562 18.4203 21.8146 18.7751C21.473 19.1298 21.0479 19.3854 20.5815 19.5165C18.8743 20 12.003 20 12.003 20C12.003 20 5.1317 20 3.42446 19.5165C2.95811 19.3854 2.53295 19.1298 2.19133 18.7751C1.84971 18.4203 1.60355 17.9788 1.47736 17.4945C0.74649 14.4703 0.946844 9.67033 1.46325 6.52015C1.58944 6.03586 1.8356 5.59436 2.17722 5.2396C2.51884 4.88484 2.944 4.62921 3.41035 4.49817C5.11759 4.01465 11.9889 4 11.9889 4C11.9889 4 18.8602 4 20.5674 4.48352C21.0337 4.61456 21.4589 4.87019 21.8005 5.22495ZM15.5024 12.0039L9.80215 15.4341V8.57366L15.5024 12.0039Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.1ace1df5c4e833226bc6aca10d5ed2e1.svg";
export { ForwardRef as ReactComponent };